const initialState = {};  // Each key will be a resourceType

export const SET_AUTHORIZATIONS = 'SET_AUTHORIZATIONS';

export default function authorizationManager(state = initialState, action) {
  const { resourceType } = action.meta || {};
  
  switch (action.type) {
    case SET_AUTHORIZATIONS:
      // Convert incoming array to object with resourceId as key and actions as boolean map
      const newAuthorizations = action.payload.reduce((acc, auth) => {
        // Convert allowedActions array to object with true values
        const actionMap = auth.allowedActions.reduce((actions, action) => {
          actions[action] = true;
          return actions;
        }, {});

        acc[auth.resourceId] = actionMap;
        return acc;
      }, {});

      // Get existing authorizations for this resource type
      const existingResourceType = state[resourceType] || {};

      return {
        ...state,
        [resourceType]: {
          ...existingResourceType,  // Keep existing resource authorizations
          ...newAuthorizations      // Add/Update new ones
        }
      };
    
    default:
      return state;
  }
}